import type { NotificationListResponseType } from "@sellar-io/api-v2/types";
import type { IconType } from "@sellar-io/components";

export const getNotificationAppearance = (
  subtype: NotificationListResponseType[number]["subtype"],
): { icon: IconType; className: string } => {
  switch (subtype) {
    case "order_delivered":
      return { icon: "CHECK_ALL", className: "bg-blue-100 text-blue-700" };
    case "order_dispatched":
      return {
        icon: "PACKAGE_VARIANT_CLOSED",
        className: "bg-purple-100 text-purple-700",
      };
    case "order_cancelled":
      return { icon: "CLOSE", className: "bg-red-100 text-red-700" };
    case "order_accepted":
      return {
        icon: "THUMB_UP_OUTLINE",
        className: "bg-orange-100 text-orange-700",
      };
    case "message_received":
      return { icon: "MESSAGE_OUTLINE", className: "bg-white text-gray-800" };
    case "order_comment_added":
      return {
        icon: "COMMENT_TEXT_OUTLINE",
        className: "bg-white text-gray-800",
      };
    case "order_sellar_credit_added_tab":
    case "sellar_credit_sole_trader_declined":
    case "sellar_credit_low_balance":
      return {
        icon: "SELLAR_NEW",
        className: "bg-gradient-to-br from-[#B557F1] to-[#D213A6] text-white",
      };
    case "order_delivery_date_changed":
      return { icon: "TRUCK_OUTLINE", className: "bg-white text-gray-800" };
    default:
      return {
        icon: "TIMER_SAND_EMPTY",
        className: "bg-yellow-100 text-yellow-800",
      };
  }
};
